export const ORDER_CHECKOUT_REQUEST: 'ORDER_CHECKOUT_REQUEST' = 'ORDER_CHECKOUT_REQUEST';
export const ORDER_CHECKOUT_SUCCESS: 'ORDER_CHECKOUT_SUCCESS' = 'ORDER_CHECKOUT_SUCCESS';
export const ORDER_CHECKOUT_FAILED: 'ORDER_CHECKOUT_FAILED' = 'ORDER_CHECKOUT_FAILED';
export const CLOSE_ORDER: 'CLOSE_ORDER' = 'CLOSE_ORDER';
